module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAgCAYAAAABtRhCAAAAAXNSR0IArs4c6QAAAT5JREFUSEtjZICC////M+plM6Qw/GdI/s/AoM3wn4EHJkcWzcjwhZGB4SoDI8PcS1MZ5jAyMv4HmcMIIowL/kv++smw5P9/BieyDCegiZGRYR8bO0PM2QmMzxnBPsti2EMry2BuAVl6aRqDC6Nu1v/U//8YZtHCZ+hmMjIxpDHqZv4/8f8/gzldLGRkOMmok/n/M8UJhFjXghKSTsZ/cOpBB5enYzdFN5NY07Gro8jCcDvshq48hNtRFFlITigMLQvnFWIPuqR+GgUpOckHZ5C6GWE3btc5cqxB6MFpIWXGkhGkdLcw05t8K6dvJcOHuPIYMc7AVxqRnA9pZmFPCjFGY1dTMoeMICXfOvw6B0+2UJIg34/3XpARpMM/ldLdh+THIKFUSu9GFN2biXRvCNO9qQ+KYrp2ZmBpil7dNQBgsbdDmd/1TwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/learnmodel/article.png
// module id = YECr
// module chunks = 96